import React from 'react';
import { ShieldCheckIcon, StarIcon, TrophyIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" glow className="my-12 rounded-[2rem] border border-brand-gold/45 bg-brand-paper/65 shadow-[0_20px_55px_rgba(34,54,70,0.1)]" data-id="element-252" data-mp="2oktlvcqttue4">
      <div className="mx-auto max-w-2xl text-center" data-id="element-253" data-mp="1vutijibz4pdd">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-forest px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-254" data-mp="1rsq2shi9uyma">
          <StarIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-255" data-mp="25q4u5rs35ggw" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-256" data-mp="3h7egqn6igomf">
          TU <span className="text-brand-purple" data-id="element-257" data-mp="3c8a6dt7uokui">BOTIQUÍN ANCESTRAL</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-258" data-mp="3cae6e02mozpi">
          El precio de lanzamiento cierra pronto. Después sube $25.000 ARS.
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-259" data-mp="4ruh7bchny6e">
        <div className="rounded-3xl border-2 border-brand-gold/65 bg-brand-paper p-5 shadow-[0_14px_40px_rgba(128,96,31,0.14)] md:p-7" data-id="element-260" data-mp="9s8sd29dzo8n">
          <div className="flex items-center gap-2 text-brand-goldDark" data-id="element-261" data-mp="eqaankyznjj2">
            <TrophyIcon className="h-4 w-4" data-id="element-262" data-mp="3d97hvrvlk4ui" />
            <StarIcon className="h-3.5 w-3.5 fill-current" data-id="element-263" data-mp="3daijbl1kl0ig" />
            <span className="text-[10px] font-bold uppercase tracking-[0.16em] md:text-xs" data-id="element-264" data-mp="3i7is43pt0hd9">
              La caja de herramientas más completa
            </span>
          </div>
          <div className="mt-4 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-265" data-mp="3rxv7lhirhkcj">
            <div data-id="element-266" data-mp="3rzoduvpgq2k0">
              <h3 className="font-serif text-xl font-bold text-brand-ink" data-id="element-267" data-mp="2uiptu0lplxfh">
                EL BOTIQUÍN ANCESTRAL™
              </h3>
              <p className="mt-1 text-sm text-brand-muted" data-id="element-268" data-mp="2zg9fhlkqlchg">
                Ebook Principal + 6 Bonos · 66 páginas + material completo
              </p>
              <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-forest" data-id="element-269" data-mp="2mhrtnq9z1k46">
                La caja de herramientas visual más completa de digitopuntura
                clínica para terapeutas y amantes de la medicina natural.
              </p>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-270" data-mp="2w9xkgwohlvhs">
              <p className="text-sm text-brand-muted line-through" data-id="element-271" data-mp="28is6kn23xda4">
                $95.000 ARS
              </p>
              <p className="font-serif text-3xl font-bold text-brand-purple" data-id="element-272" data-mp="23kqn410rrby4">
                $27.990 ARS
              </p>
            </div>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-273" data-mp="2dg246pzngv91">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-274" data-mp="92h6qlpslrw">
            → QUIERO MI BOTIQUÍN ANCESTRAL $27.990
          </CTAButton>
        </motion.div>
        <p className="mt-5 text-center text-xs text-brand-muted md:text-sm" data-id="element-275" data-mp="3nfv2s6hoa3ns">
          <ShieldCheckIcon className="mr-1 inline h-4 w-4 text-brand-forest" data-id="element-276" data-mp="3rgezj8yc359e" />
          Garantía 7 días · Descarga inmediata · Pago seguro · Mercado Pago
        </p>
      </div>
    </Section>;
}